<template>
	<div class="flex items-center gap-2 rounded-md text-white text-xs bg-grey-1 h-10 px-3">
		<img :src="require(`@/assets/logo/abx.png`)" class="h-6">
		<span class="text-nowrap">HIN: {{ hin }}</span>
	</div>
</template>

<script>
import LogoAbx from '@/components/svg/logo-abx.vue'

export default {
	name: 'TradingType',
	components: {
		LogoAbx,
	},
	data() {
		return {
		}
	},
	computed: {
		hin() {
			return this.$store.getters.getHin
		},
		hinKinesis() {
			return this.$store.getters.getHinKinesis
		},
		tradingType() {
			return this.$store.state.tradingType
		},
	},
	methods: {
		changeTradingType(tradingType) {
			this.$store.dispatch('changeTradingType', tradingType)
		}
	}
}
</script>

<style scoped></style>